"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  parseCurrency: true,
  removeNonNumericString: true,
  formatPhoneNumber: true,
  getIsRewardValid: true,
  getIsRewardRedeemable: true,
  parseRewardInfo: true,
  moment: true,
  getOrderStatusDetails: true,
  getIsOrderOpenHoursLT: true,
  getIsOpenForGivenTime: true,
  getIsProductActive: true,
  isMobileBrowser: true,
  currencyRounding: true,
  calculatePointsEarned: true,
  latlngDistance: true,
  getCartItemTotal: true,
  getSelectedModifierGroupsWithDetails: true
};
exports.currencyRounding = currencyRounding;
exports.calculatePointsEarned = calculatePointsEarned;
exports.latlngDistance = latlngDistance;
exports.getCartItemTotal = getCartItemTotal;
exports.getSelectedModifierGroupsWithDetails = getSelectedModifierGroupsWithDetails;
exports.isMobileBrowser = exports.getIsProductActive = exports.getIsOpenForGivenTime = exports.getIsOrderOpenHoursLT = exports.getOrderStatusDetails = exports.moment = exports.parseRewardInfo = exports.getIsRewardRedeemable = exports.getIsRewardValid = exports.formatPhoneNumber = exports.removeNonNumericString = exports.parseCurrency = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _lodash = require("lodash");

var _container = require("./container");

Object.keys(_container).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _container[key];
    }
  });
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var parseCurrency = function parseCurrency(amount) {
  var amountNumber;

  if (amount == null) {
    return 0;
  }

  if (typeof amount === 'string') {
    amountNumber = Number(amount);
  } else {
    amountNumber = amount;
  }

  if (isNaN(amountNumber)) {
    // console.warn('amount is not a valid number')
    return 0;
  }

  return Math.round(amountNumber * Math.pow(10, 2)) / Math.pow(10, 2);
};

exports.parseCurrency = parseCurrency;

var removeNonNumericString = function removeNonNumericString(str) {
  if (!str) {
    return '';
  }

  return str.replace(/\D+/g, '');
};

exports.removeNonNumericString = removeNonNumericString;

var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }

  var phoneNumberStr = phoneNumber + '';
  return removeNonNumericString(phoneNumberStr).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3');
}; // Checks if given reward is currently valid


exports.formatPhoneNumber = formatPhoneNumber;

var getIsRewardValid = function getIsRewardValid(_ref) {
  var _ref$isLoggedIn = _ref.isLoggedIn,
      isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
      rewardDetails = _ref.rewardDetails,
      _ref$isFirstOrder = _ref.isFirstOrder,
      isFirstOrder = _ref$isFirstOrder === void 0 ? false : _ref$isFirstOrder,
      productsDetails = _ref.productsDetails,
      cartSubTotal = _ref.cartSubTotal,
      _ref$redeemedRewardCo = _ref.redeemedRewardCount,
      redeemedRewardCount = _ref$redeemedRewardCo === void 0 ? 0 : _ref$redeemedRewardCo,
      _ref$userPointsWithPr = _ref.userPointsWithPromoApplied,
      userPointsWithPromoApplied = _ref$userPointsWithPr === void 0 ? 0 : _ref$userPointsWithPr;
  var ERROR = {
    INVALID_REWARD: {
      valid: false,
      message: 'Reward is invalid'
    },
    NOT_LOGGED_IN: {
      valid: false,
      message: 'Please log in before redeeming rewards'
    },
    NOT_ENOUGH_POINTS: {
      valid: false,
      message: 'Not Enough Points'
    },
    FREE_REWARD_EMPTY_CART: {
      valid: false,
      message: 'Free Reward cannot be redeemed with empty cart'
    },
    DISCOUNT_EMPTY_CART: {
      valid: false,
      message: 'Discount cannot be redeemed with empty cart'
    },
    INVALID_PRODUCT: {
      valid: false,
      message: 'Product is Invalid'
    },
    PRODUCT_SOLDOUT: {
      valid: false,
      message: 'Product is temporarily Out Of Stock'
    },
    MAXIMUM_COUNT: {
      valid: false,
      message: 'You cannot redeem any more of this reward'
    },
    INVALID_FIELD: {
      valid: false,
      message: 'This Reward cannot be redeemed'
    },
    INVALID_COUNT: {
      valid: false,
      message: 'You must redeem 1 or more'
    },
    INVALID_SUBTOTAL: {
      valid: false,
      message: 'SubTotal cannot be negative'
    },
    NOT_MET_MIN_SUBTOTAL: {
      valid: false,
      message: 'SubTotal is too low'
    }
  };

  if (!rewardDetails) {
    return ERROR.INVALID_REWARD;
  }

  if (rewardDetails.requiresLogin && !isLoggedIn) {
    return ERROR.NOT_LOGGED_IN;
  }

  if (cartSubTotal < rewardDetails.minimumSubTotal) {
    return ERROR.NOT_MET_MIN_SUBTOTAL;
  }

  if (redeemedRewardCount <= 0) {
    return ERROR.INVALID_COUNT;
  }

  if (cartSubTotal < 0) {
    return ERROR.INVALID_SUBTOTAL;
  }

  if (isFirstOrder && rewardDetails.requiredPoints === 0 && cartSubTotal <= 0) {
    return ERROR.FREE_REWARD_EMPTY_CART;
  }

  if (rewardDetails.discountSubtotal > 0 && cartSubTotal <= 0) {
    return ERROR.DISCOUNT_EMPTY_CART;
  }

  if (redeemedRewardCount > rewardDetails.maximumCount) {
    return ERROR.MAXIMUM_COUNT;
  }

  if (rewardDetails.productId && !productsDetails[rewardDetails.productId]) {
    return ERROR.INVALID_PRODUCT;
  }

  if (rewardDetails.productId && !getIsProductActive(productsDetails[rewardDetails.productId])) {
    return ERROR.PRODUCT_SOLDOUT;
  }

  if (userPointsWithPromoApplied < 0) {
    return ERROR.NOT_ENOUGH_POINTS;
  }

  return {
    valid: true
  };
}; // Checks if given reward is redeemable.


exports.getIsRewardValid = getIsRewardValid;

var getIsRewardRedeemable = function getIsRewardRedeemable(_ref2) {
  var _ref2$isLoggedIn = _ref2.isLoggedIn,
      isLoggedIn = _ref2$isLoggedIn === void 0 ? false : _ref2$isLoggedIn,
      rewardDetails = _ref2.rewardDetails,
      _ref2$isFirstOrder = _ref2.isFirstOrder,
      isFirstOrder = _ref2$isFirstOrder === void 0 ? false : _ref2$isFirstOrder,
      productsDetails = _ref2.productsDetails,
      cartSubTotal = _ref2.cartSubTotal,
      _ref2$redeemedRewardC = _ref2.redeemedRewardCount,
      redeemedRewardCount = _ref2$redeemedRewardC === void 0 ? 0 : _ref2$redeemedRewardC,
      _ref2$userPointsWithP = _ref2.userPointsWithPromoApplied,
      userPointsWithPromoApplied = _ref2$userPointsWithP === void 0 ? 0 : _ref2$userPointsWithP;
  return getIsRewardValid({
    isLoggedIn: isLoggedIn,
    rewardDetails: rewardDetails,
    isFirstOrder: isFirstOrder,
    productsDetails: productsDetails,
    cartSubTotal: cartSubTotal,
    redeemedRewardCount: redeemedRewardCount + 1,
    userPointsWithPromoApplied: userPointsWithPromoApplied - rewardDetails.requiredPoints
  });
}; // Parses reward info


exports.getIsRewardRedeemable = getIsRewardRedeemable;

var parseRewardInfo = function parseRewardInfo(_ref3) {
  var rewardInfo = _ref3.rewardInfo,
      _ref3$isFirstOrder = _ref3.isFirstOrder,
      isFirstOrder = _ref3$isFirstOrder === void 0 ? false : _ref3$isFirstOrder,
      _ref3$productsDetails = _ref3.productsDetails,
      productsDetails = _ref3$productsDetails === void 0 ? {} : _ref3$productsDetails,
      cartSubTotal = _ref3.cartSubTotal,
      count = _ref3.count;
  var type = rewardInfo.type,
      value = rewardInfo.value,
      points = rewardInfo.points,
      imageUrl = rewardInfo.imageUrl,
      _rewardInfo$minimumSu = rewardInfo.minimumSubTotal,
      minimumSubTotal = _rewardInfo$minimumSu === void 0 ? 0 : _rewardInfo$minimumSu,
      _rewardInfo$appliedDe = rewardInfo.appliedDefault,
      appliedDefault = _rewardInfo$appliedDe === void 0 ? false : _rewardInfo$appliedDe,
      _rewardInfo$requiresL = rewardInfo.requiresLogin,
      requiresLogin = _rewardInfo$requiresL === void 0 ? true : _rewardInfo$requiresL;
  var rewardDetails = {
    // Descriptions
    name: null,
    imageUrl: imageUrl,
    maximumCount: 100,
    appliedDefault: appliedDefault,
    requiresLogin: requiresLogin,
    // WITH
    requiredPoints: null,
    totalRequiredPoints: null,
    // FOR
    discountSubtotal: null,
    totalDiscountSubtotal: null,
    productId: null,
    price: null,
    rewardValue: null,
    totalRewardValue: null,
    // CONDITION
    minimumSubTotal: minimumSubTotal
  }; // Type Follows With/For/Condition pattern
  // What are you redeeming WITH, what are you redeeming FOR, and in what CONDITION can you redeem it.
  // For instance, Free/Product/Birthday will indicate free product on birthday

  switch (type) {
    case 'Free/Product/MinSubTotal':
      {
        if (minimumSubTotal == null || cartSubTotal == null) {
          return null;
        }

        rewardDetails.maximumCount = 1;
        rewardDetails.requiredPoints = 0;
        rewardDetails.totalRequiredPoints = 0;
        var productDetails = productsDetails[value];

        if (productDetails) {
          rewardDetails.productId = productDetails.id;
          rewardDetails.name = productDetails.name;
          rewardDetails.price = productDetails.price;
          rewardDetails.rewardValue = productDetails.price;
          rewardDetails.totalRewardValue = productDetails.price;
        }
      }
      break;

    case 'Free/DiscountPercent/MinSubTotal':
      {
        if (minimumSubTotal == null || cartSubTotal == null) {
          return null;
        }

        rewardDetails.name = "$".concat(value * 100, "% OFF");
        var discountPercent = parseFloat(value) || 0;
        rewardDetails.maximumCount = 1;
        rewardDetails.requiredPoints = 0;
        rewardDetails.totalRequiredPoints = 0;
        rewardDetails.discountSubtotal = currencyRounding(discountPercent * cartSubTotal);
        rewardDetails.totalDiscountSubtotal = rewardDetails.discountSubtotal;
        rewardDetails.rewardValue = rewardDetails.discountSubtotal;
        rewardDetails.totalRewardValue = rewardDetails.discountSubtotal;
      }
      break;

    case 'FreeFirstOrderOrPoints/Discount':
      {
        rewardDetails.name = "$".concat(value, " OFF");
        var discount = currencyRounding(parseFloat(value) || 0);
        rewardDetails.discountSubtotal = discount;
        rewardDetails.totalDiscountSubtotal = currencyRounding(discount * count);
        rewardDetails.rewardValue = discount;
        rewardDetails.totalRewardValue = rewardDetails.totalDiscountSubtotal;

        if (isFirstOrder) {
          rewardDetails.requiredPoints = 0;
          rewardDetails.totalRequiredPoints = 0;
          rewardDetails.maximumCount = 1;
        } else {
          rewardDetails.requiredPoints = points;
          rewardDetails.totalRequiredPoints = points * count;
        }
      }
      break;

    case 'Points/Discount':
      {
        rewardDetails.name = "$".concat(value, " OFF");

        var _discount = currencyRounding(parseFloat(value) || 0);

        rewardDetails.discountSubtotal = _discount;
        rewardDetails.totalDiscountSubtotal = currencyRounding(_discount * count);
        rewardDetails.rewardValue = _discount;
        rewardDetails.totalRewardValue = rewardDetails.totalDiscountSubtotal;
        rewardDetails.requiredPoints = points;
        rewardDetails.totalRequiredPoints = points * count;
      }
      break;

    case 'FreeFirstOrderOrPoints/Product':
      {
        var _productDetails = productsDetails[value];

        if (_productDetails) {
          rewardDetails.productId = _productDetails.id;
          rewardDetails.name = _productDetails.name;
          rewardDetails.price = _productDetails.price;
          rewardDetails.rewardValue = _productDetails.price;
          rewardDetails.totalRewardValue = currencyRounding(_productDetails.price * count);
        }

        if (isFirstOrder) {
          rewardDetails.requiredPoints = 0;
          rewardDetails.totalRequiredPoints = 0;
          rewardDetails.maximumCount = 1;
        } else {
          rewardDetails.requiredPoints = points;
          rewardDetails.totalRequiredPoints = points * count;
        }
      }
      break;

    case 'Points/Product':
      {
        var _productDetails2 = productsDetails[value];

        if (_productDetails2) {
          rewardDetails.productId = _productDetails2.id;
          rewardDetails.name = _productDetails2.name;
          rewardDetails.price = _productDetails2.price;
          rewardDetails.rewardValue = _productDetails2.price;
          rewardDetails.totalRewardValue = currencyRounding(_productDetails2.price * count);
        }

        rewardDetails.requiredPoints = points;
        rewardDetails.totalRequiredPoints = points * count;
      }
      break;
  }

  return rewardDetails;
};

exports.parseRewardInfo = parseRewardInfo;

var moment = function moment() {
  return _momentTimezone.default.apply(void 0, arguments).tz('America/Vancouver');
}; // Given targetTimeMoment, find current open status, and next open, next close time.


exports.moment = moment;

var getOrderStatusDetails = function getOrderStatusDetails(_ref4) {
  var hoursLT = _ref4.hoursLT,
      _ref4$targetTimeMomen = _ref4.targetTimeMoment,
      targetTimeMoment = _ref4$targetTimeMomen === void 0 ? moment() : _ref4$targetTimeMomen,
      _ref4$orderOpenAfterM = _ref4.orderOpenAfterMoment,
      orderOpenAfterMoment = _ref4$orderOpenAfterM === void 0 ? moment(0) : _ref4$orderOpenAfterM;

  if (!hoursLT) {
    throw new Error('Missing hoursLT');
  }

  if (!targetTimeMoment) {
    throw new Error('Missing targetTimeMoment');
  }

  if (!orderOpenAfterMoment) {
    throw new Error('Missing orderOpenAfter');
  } // 1. Check if targetTime is before the orderOpenAfterMoment


  if (targetTimeMoment.isBefore(orderOpenAfterMoment)) {
    // 2. Ordering is closed, find next opening hour
    var isOpenWithDetails = getIsOpenWithDetails({
      hoursLT: hoursLT,
      targetTimeMoment: orderOpenAfterMoment
    });

    if (isOpenWithDetails.isOpen) {
      // 3. Order is closed and reopens at orderOpenAfterMoment
      return {
        isOpen: false,
        openMoment: orderOpenAfterMoment,
        isSameDay: orderOpenAfterMoment.dayOfYear() === targetTimeMoment.dayOfYear()
      };
    } else {
      // 4. Order is closed and reopens at isOpenWithDetails.openMoment
      return {
        isOpen: false,
        openMoment: isOpenWithDetails.openMoment,
        isSameDay: isOpenWithDetails.openMoment ? isOpenWithDetails.openMoment.dayOfYear() === targetTimeMoment.dayOfYear() : false
      };
    }
  } // 5. Find current and next hour block at targetTimeMoment


  return getIsOpenWithDetails({
    hoursLT: hoursLT,
    targetTimeMoment: targetTimeMoment
  });
};

exports.getOrderStatusDetails = getOrderStatusDetails;

function getIsOpenWithDetails(_ref5) {
  var hoursLT = _ref5.hoursLT,
      _ref5$targetTimeMomen = _ref5.targetTimeMoment,
      targetTimeMoment = _ref5$targetTimeMomen === void 0 ? moment() : _ref5$targetTimeMomen;

  if (!hoursLT) {
    throw new Error('Missing hoursLT');
  }

  if (!targetTimeMoment) {
    throw new Error('Missing targetTimeMoment');
  }

  var targetWeekday = targetTimeMoment.weekday(); // 1. Check TargetTime is open

  var dayHoursLT = hoursLT[targetWeekday];

  if (dayHoursLT && dayHoursLT.length > 0) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = dayHoursLT[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var dayHourLT = _step.value;
        var openLT = dayHourLT.openLT,
            closeLT = dayHourLT.closeLT;
        var openMoment = moment(openLT, 'LT');
        var closeMoment = moment(closeLT, 'LT'); // 2. Check if dayHourLT is upcoming

        var isUpcoming = targetTimeMoment.isBefore(openMoment);

        if (isUpcoming) {
          return {
            isOpen: false,
            openMoment: openMoment,
            isSameDay: true
          };
        } // 3. Check if the store is currently open


        var isOpen = targetTimeMoment.isBetween(openMoment, closeMoment, '[]');

        if (isOpen) {
          return {
            isOpen: true,
            closeMoment: closeMoment,
            isSameDay: true
          };
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } // 4. Store is closed and does not reopen today.
  // Find next reopen time if available.


  for (var weekDayDeltaIndex = 1; weekDayDeltaIndex < 6; weekDayDeltaIndex++) {
    var currentWeekday = (targetWeekday + weekDayDeltaIndex) % 7;
    var _dayHoursLT = hoursLT[currentWeekday];

    if (_dayHoursLT && _dayHoursLT.length > 0) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _dayHoursLT[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _dayHourLT = _step2.value;
          var _openLT = _dayHourLT.openLT;

          var _openMoment = moment(_openLT, 'LT').add(weekDayDeltaIndex, 'days'); // 5. Check if dayHourLT is upcoming


          var _isUpcoming = targetTimeMoment.isBefore(_openMoment);

          if (_isUpcoming) {
            return {
              isOpen: false,
              openMoment: _openMoment,
              isSameDay: false
            };
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } // 6. The store does not open in the next 6 days


  return {
    isOpen: false,
    openMoment: null,
    isSameDay: false
  };
}

var getIsOrderOpenHoursLT = function getIsOrderOpenHoursLT(_ref6) {
  var hoursLT = _ref6.hoursLT,
      _ref6$targetTimeMomen = _ref6.targetTimeMoment,
      targetTimeMoment = _ref6$targetTimeMomen === void 0 ? moment() : _ref6$targetTimeMomen;

  if (!hoursLT || !targetTimeMoment) {
    return false;
  } // const exampleHoursLT = {
  //   0: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   1: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   2: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   3: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   4: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   5: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  //   6: [{openLT: '10 AM', closeLT: '2 PM'}, {openLT: '3 PM', closeLT: '11 PM'}],
  // }


  var targetWeekday = targetTimeMoment.weekday();
  var targetTimeLT = targetTimeMoment.format('LT');
  var dayHoursLT = hoursLT[targetWeekday];

  if (dayHoursLT) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = dayHoursLT[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var openCloseLT = _step3.value;

        if (openCloseLT) {
          var openLT = openCloseLT.openLT,
              closeLT = openCloseLT.closeLT;
          var isOpen = isBetweenTime({
            targetTimeLT: targetTimeLT,
            openLT: openLT,
            closeLT: closeLT
          });

          if (isOpen) {
            return true;
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  return false;
}; // Checks if targetTimeLT is between openLT and closeLT inclusive.


exports.getIsOrderOpenHoursLT = getIsOrderOpenHoursLT;

function isBetweenTime(_ref7) {
  var targetTimeLT = _ref7.targetTimeLT,
      openLT = _ref7.openLT,
      closeLT = _ref7.closeLT;

  if (!openLT || !closeLT || !targetTimeLT) {
    return false;
  }

  var openMoment = moment(openLT, 'LT');
  var closeMoment = moment(closeLT, 'LT');
  var targetTimeMoment = moment(targetTimeLT, 'LT');
  return targetTimeMoment.isBetween(openMoment, closeMoment, '[]');
} // Deprecated in favour of getIsOrderOpenHoursLT


var getIsOpenForGivenTime = function getIsOpenForGivenTime(_ref8) {
  var hours = _ref8.hours,
      targetDate = _ref8.targetDate,
      time = _ref8.time,
      waitTime = _ref8.waitTime;

  if (!hours || !targetDate || !time) {
    return false;
  }

  var weekday = targetDate.weekday(); // get time from hours

  var open = (0, _lodash.get)(hours[weekday], 'open');
  var close = (0, _lodash.get)(hours[weekday], 'close');

  if (!open || !close) {
    return false;
  }

  var openMoment = moment(open);
  var closeMoment = moment(close);
  var openTime = moment(targetDate).hours(openMoment.hours()).minutes(openMoment.minutes()).seconds(0);
  var closeTime = moment(targetDate).hours(closeMoment.hours()).minutes(closeMoment.minutes()).seconds(0);
  var orderCloseMoment = moment(closeTime).subtract(waitTime, 'minutes');

  if (openTime.isSame(closeTime)) {
    return false;
  }

  var todayOrderClose;

  if (openTime.isBefore(closeTime)) {
    todayOrderClose = orderCloseMoment;
  } else {
    todayOrderClose = moment(orderCloseMoment).add(1, 'days');
  }

  return time.isBetween(openTime, todayOrderClose, '[]');
};

exports.getIsOpenForGivenTime = getIsOpenForGivenTime;

var getIsProductActive = function getIsProductActive(productDetails) {
  if (!productDetails) {
    // Product doens't exist
    return false;
  } // Since Dec 16 2018, active property is deprecated in favor of activeAfter


  var activeAfter = (0, _lodash.get)(productDetails, 'activeAfter');

  if (activeAfter) {
    var activeAfterMoment = moment(activeAfter);

    if (moment().isAfter(activeAfterMoment)) {
      return true;
    } else {
      return false;
    }
  }

  var active = (0, _lodash.get)(productDetails, 'active'); // If active property doesn't exist, this means product is active

  if (active === undefined || active === true) {
    return true;
  }

  if (active === false) {
    return false;
  } // As a fallback


  return true;
};

exports.getIsProductActive = getIsProductActive;

var isMobileBrowser = function isMobileBrowser() {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

exports.isMobileBrowser = isMobileBrowser;

function currencyRounding(amount) {
  return Math.round(amount * Math.pow(10, 2)) / Math.pow(10, 2);
}

function calculatePointsEarned(subTotal, pointsInterval, pointsPerInterval) {
  return Math.max(Math.floor(Math.floor(subTotal / pointsInterval) * pointsPerInterval), 0);
} // Return approx distance between two points in km


function latlngDistance(lat1, lon1, lat2, lon2) {
  var p = 0.017453292519943295; // Math.PI / 180

  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p)) / 2;
  return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
}

function getCartItemTotal(_ref9) {
  var price = _ref9.price,
      count = _ref9.count,
      selectedModifierGroupsWithDetails = _ref9.selectedModifierGroupsWithDetails;

  if (!selectedModifierGroupsWithDetails) {
    return Math.max(price * count, 0);
  }

  var modifierTotalPrice = selectedModifierGroupsWithDetails.reduce(function (prev, modifierGroupDetails) {
    if (!modifierGroupDetails || !modifierGroupDetails.selectedModifierItemsObj) {
      return prev;
    }

    return prev + Object.entries(modifierGroupDetails.selectedModifierItemsObj).reduce(function (prev, _ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
          modifierItemId = _ref11[0];

      if (modifierGroupDetails.modifierItems[modifierItemId].defaultValue) {
        var modifier_price = modifierGroupDetails.modifierItems[modifierItemId].price;
        prev += modifier_price;
      }

      return prev;
    }, 0);
  }, 0);
  return Math.max((price + modifierTotalPrice) * count, 0);
}

function getSelectedModifierGroupsWithDetails(_ref12) {
  var selectedModifiers = _ref12.selectedModifiers,
      modifierGroups = _ref12.modifierGroups;
  return Object.entries(selectedModifiers).reduce(function (prev, _ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        modifierGroupId = _ref14[0],
        selectedModifierItemsObj = _ref14[1];

    if (modifierGroups[modifierGroupId]) {
      prev.push(_objectSpread({}, modifierGroups[modifierGroupId], {
        selectedModifierItemsObj: selectedModifierItemsObj
      }));
    }

    return prev;
  }, []);
}